import type { UserSessionResponse } from '@coorum-research/shared-common/api-response/user.schema'
import type { CreateUserSessionParams } from '@coorum-research/shared-common/types/user.type'
import http from '../apis/http'
import { setSession } from '../utils/user-session-storage.util'

export const userApi = () => {

  /**
   * create session & save to local storage
   */
  const createUserSession = async (data: CreateUserSessionParams) => {
    const response = await http.post<UserSessionResponse>(`/create-session`, data)
    const userSession = response.data
    setSession(userSession)
    return userSession
  }

  return {
    createUserSession,
  }
}
